export type FetchStartAction = {
  type: string,
  origin?: string
}

export type FetchSuccessAction<T> = {
  type: string,
  payload: { resources?: T },
  origin?: string
}

export type FetchErrorAction<T> = {
  type: string,
  payload: { error: any, resources?: T },
  origin?: string
}

export type FetchAction<T> =
  | FetchStartAction
  | FetchSuccessAction<T>
  | FetchErrorAction<T>

export type FetchActionCreator<T> = {
  fetchStart: () => FetchStartAction
  fetchSuccess: (resources?: T) => FetchSuccessAction<T>
  fetchError: (error: any, resources?: T) => FetchErrorAction<T>
}

export const isFetchSuccessAction = <T>(action: FetchAction<T>): action is FetchSuccessAction<T> => {
  return action.type.endsWith('SUCCESS')
}

export const isFetchErrorAction = <T>(action: FetchAction<T>): action is FetchErrorAction<T> => {
  return !!(action as FetchErrorAction<T>).payload.error
}
